import React, { Component, useCallback } from "react";
import _, { isEmpty, get } from "lodash";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import moment from "moment";
import { Link } from "react-router-dom";

import asyncRoute from "../../../helpers/hoc/asyncRoute";
import routes from "../../../routes";
import BinarySelect from "../../../components/BinarySelect";
import MultiSelect from "../../../components/FormElements/MultiSelect";

import Input from "../../../components/FormElements/Input";
// import File from '../../../../../components/FormElements/File';
import Textarea from "../../../components/FormElements/Textarea";
// import Select from '../../../components/FormElements/Select';
import Select from "react-select";
import DatePicker from "../../../components/Datepicker";
import ModalConfirmation from "../../../components/ModalConfirmation";
// import MultiSelect from '../../../components/FormElements/MultiSelect';
import TimePicker from "../../../components/FormElements/TimePicker";
import {
  handleFieldError,
  initializeForm,
  handleError,
} from "../../../utils/form-validation";
import {
  formFields,
  successfullyMessage,
  ModelSelect,
  ModelTypeSelect,
  confirmationMessage
} from "./constant";
// import { bidderReport } from '../Io/constant';
import {
  getAllCampaignListAction,
  getListByIdAdminMarginAction,
  postUpdatetionAdminMarginAction,
  getPlaformWiseAction
} from "../../../actions";
import { sortArray } from "../../../selectors";
import CheckboxGroup from "../../../components/FormElements/CheckboxGroup";
import RadioGroup from "../../../components/FormElements/RadioGroup";
import { log } from "async";
import "../ro.scss";
import { imageUrl } from "../../../constants/configuration";
// import BinarySelect from '../../../components/BinarySelect'

import { postCreationAdminMarginAction } from "../../../actions";
import ToastModal from "../../../components/ToastModal";

const Card = asyncRoute(() => import("../../../components/Card"));
const BreadCrumb = asyncRoute(() => import("../../../components/BreadCrumb"));

class index extends Component {
  constructor(props) {
    super(props);
    this.fileRef = React.createRef();
    this.state = {
      form: {},
      touched: {},
      errors: {},
      submited: false,
      confirmationOpen: false,
      confirmationInfo: "",
      getCampaign: "",
      getModel: "",
      getType: "",
      getUpdatePlatform: "",
      getUpdateAdType: "",
      fetchCampaign: [],
      campaignResponse: [],
      displayData: [],
      platformData: [],
      updatePlatformList: [],
      platformAndAdTypeData: [],
      adTypesOption: [],
      validationCampaign: false,
      validationModel: false,
      validationType: false,
      validationNewPlatform: false,
      validationNewAdType: false,
      validationValue: false,
      enableToast: false,
      toastStatus: "",
      toastMsg: "",
      confirmationMsg: ""
    };
  }

  async componentWillMount() {
    const { configurationList } = this.props;
    const currency = get(
      configurationList.find((currency) => currency.attrName === "CURRENCY"),
      "attributeValues",
      []
    );
    let isAuthenticated = JSON.parse(localStorage.getItem("AuthData"));
    if (isEmpty(isAuthenticated)) {
      const { history } = this.props;
      history.push(routes.preSignIn);
    }
    const { form, errors } = initializeForm(formFields);

    await this.AllCampaignApi();
    await this.platformWiseFunction();
    this.editId();
  }

  async AllCampaignApi() {
    const { history, tenantId, authToken, userId, getAllCampaignListAction } =
      this.props;
    const {
      responseCode: { status = "" },
      responseList,
    } = await getAllCampaignListAction({ tenantId, authToken, userId });
    if (status == "Success") {
      const data = responseList.map((item) => {
        return { label: item.name, value: item.name };
      });
      // console.log(data, "Campains")
      this.setState({ campaignResponse: responseList });
      this.setState({ fetchCampaign: data });
    }
  }

  async platformWiseFunction() {
    const { history, tenantId, authToken, userId, getPlaformWiseAction } =
      this.props;
    const {
      responseCode: { status = "" },
      responseList,
    } = await getPlaformWiseAction({ tenantId, authToken, userId });
    if (status == "Success") {
      const data = responseList.map((item) => {
        return { label: item.platform, value: item.platform, name: 'platform' };
      });
      this.setState({ updatePlatformList: data })
      this.setState({ platformAndAdTypeData: responseList })

    }
  }

  editId = async () => {
    const {form} = this.state
    const {
      match: {
        params: { id },
      },
      tenantId,
      authToken,
      userId,
      getListByIdAdminMarginAction,
    } = this.props;

    if (id) {
      const roId = id;
      const {
        responseCode: { status = "" },
        responseList,
      } = await getListByIdAdminMarginAction({
        tenantId,
        authToken,
        userId,
        roId,
      });
      // console.log(responseList, "responseList");
      if (status === "Success" && responseList.length > 0) {
        let {
          campaignName,
          model,
          type,
          value,
          curPlatform,
          newPlatform,
          curAdtype,
          newAdType
        } = responseList[0];
        form.marginValue = value.toString()


        let editGetCampaign = {
          label: campaignName,
          value: campaignName,
        };

        let editGetModel = {
          label: model == 'cpc' ? 'CPC' : 'CPM',
          value: model,
          name: "model",
        };

        let editGetType = {
          label: type == 'fixedvalue' ? 'Fixed Value' : '%Value',
          value: type,
          name: "Type",
        };

        let editGetPlatform = {
          label: newPlatform,
          value: newPlatform,
          name: "platform",
        };

        let editGetAdType = {
          label: newAdType,
          value: newAdType,
          name: "adType",
        };

        // console.log("getModel", editGetModel);
        this.setState({ getCampaign: editGetCampaign });
        this.setState({ getModel: editGetModel });
        this.setState({ getType: editGetType });
        this.setState({ platformData: editGetPlatform });
        this.setState({ displayData: editGetAdType });
        this.setState({ form });
      }
    }
  };

  handleCampaignChange = (selected) => {
    const { campaignResponse } = this.state;
    const filterCampaign = campaignResponse.filter(
      (e) => e.name == selected.value
    );
    const displayVariable = filterCampaign.map((e) => {
      return { label: e.adtype, value: e.adtype };
    });
    const platformVariable = filterCampaign.map((e) => {
      return { label: e.platform, value: e.platform };
    });

    if (selected.value) {
      this.setState({ validationCampaign: false });
      this.setState({ getCampaign: selected });
      this.setState({ displayData: displayVariable });
      this.setState({ platformData: platformVariable });
    } else {
      this.setState({ validationCampaign: true });
    }

    // console.log(displayVariable,"displayVariable",platformVariable)
  };

  handleAdminChange = (selected) => {
    const { platformAndAdTypeData } = this.state

    if (selected.name == "model") {
      if (selected.value) {
        this.setState({ validationModel: false });
        this.setState({ getModel: selected });
      } else {
        this.setState({ validationModel: true });
      }
    } else if (selected.name == "Type") {
      let {errors,form,touched} = this.state;
      const {match: {
        params: { id },
      }} = this.props;
      if (selected.value) {
        if(selected.value == '%value'){
          formFields.marginValue.max = 100
        }
        else{
          formFields.marginValue.max = 99999
        }
        if(form.marginValue !=''){
          let { error } = handleFieldError(
            form['marginValue'],
            formFields['marginValue']
          );
          if(id){
            touched['marginValue'] = true
          }
          if(touched.marginValue){
          errors['marginValue'] = error;
          }
        }
        this.setState({ validationType: false,getType: selected,errors,touched });
      } else {
        this.setState({ validationType: true });
      }
    } else if (selected.name == "adType") {
      if (selected.value) {
        console.log(selected.value)
        this.setState({ validationNewAdType: false });
        this.setState({ getUpdateAdType: selected });
      } else {
        this.setState({ validationNewAdType: true });
      }
    } else if (selected.name == "platform") {
      const filterAdtypes = platformAndAdTypeData.filter(
        (e) => e.platform == selected.value
      );
      const AdTypesData = filterAdtypes.map((e) => {
        // console.log(e, "XX");
        let adTypesArray = []
        e.adTypes.forEach((ad) => {
          adTypesArray.push({ label: ad.value, value: ad.value, name: 'adType' })
        })
        this.setState({ adTypesOption: adTypesArray })
      });

      if (selected.value) {
        this.setState({ validationNewPlatform: false });
        this.setState({ getUpdatePlatform: selected });
      } else {
        this.setState({ validationNewPlatform: true });
      }
    }
  };

  handleChange = (e) => {
    let { form } = this.state;
    let { value, name } = e.target;
    form[name] = value;
    this.setState({ form });
  };

  handleTouch = (e) => {
    let { touched, form, errors } = this.state;
    let { error } = handleFieldError(
      form[e.target.name],
      formFields[e.target.name]
    );
    errors[e.target.name] = error;
    touched[e.target.name] = true;
    this.setState({ touched, errors });
  };

  toggleModal = (confirmation) => {
    const { confirmationOpen } = this.state;
    this.setState({
      confirmationOpen: !confirmationOpen,
      confirmationInfo: confirmation,
    });
  };

  confirmationCallBack = (success, info) => {
    const { confirmationOpen } = this.state;
    const { match: { params: { id } } } = this.props;
    if (success && info.action.type === "Confirmation") {
      if (id) {
        this.UpdateAdminMargin();
      } else {
        this.createAdminMargin();
      }
      // this.submitForm();
    } else if (info.action.type === "alert") {
      this.setState({ confirmationOpen: !confirmationOpen }, () => {
        const { history } = this.props;
        history.push(
          "/" + routes.mainRoute + "/" + routes.containers.adminMargin
        );
      });
      return;
    } else if (info.action.type === 'Success') {
      this.setState({ confirmationOpen: !confirmationOpen }, () => {
        const { history } = this.props;
        history.push(
          "/" + routes.mainRoute + "/" + routes.containers.adminMargin
        );
      });
      return;
    }

    this.setState({ confirmationOpen: false });
  };

  async submitForm() {
    const {
      match: {
        params: { id },
      },
      addIoReportAction,
      tenantId,
      authToken,
      userId,
    } = this.props;
    const { form } = this.state;
    const { advertiserId, brief, startDate, endDate, name, budget } = form;
    let addParams = { addup: "auto" };
    let data = {
      advertiserId,
      brief,
      startDate: moment(startDate).format("MMM DD, YYYY"),
      endDate: endDate ? moment(endDate).format("MMM DD, YYYY") : null,
      // endDate: endDate === '' ? moment('Dec 31, 2050', 'MMM DD, YYYY').format('MMM DD, YYYY') : moment(endDate).format('MMM DD, YYYY'),
      name: name.replace(/^\s+|\s+$/gm, ""),
      budget,
      rec_active: 1,
      currency: [{ currency: form.currency, ti_isactive: 1 }],
      geo: [],
    };
    if (id) {
      addParams = { addup: id };
    }
    // console.log(data)
    // return false
    const { desc = "", status = "" } = await (addIoReportAction(
      tenantId,
      authToken,
      userId,
      data,
      addParams
    ) || "");

    if (status === "Success") {
      this.setState({ confirmationOpen: false }, () => {
        this.toggleModal(successfullyMessage);
      });
      return;
    } else {
      const info = { action: { confirmationMessage: desc, type: "error" } };
      this.toggleModal(info);
    }
  }

  toggleAlertModal = (confirmation) => {
    const { confirmationOpen } = this.state;
    this.setState({
      confirmationOpen: !confirmationOpen,
      confirmationInfo: confirmation,
    });
  };

  createAdminMargin = async (e) => {
    const {
      form,
      getCampaign,
      getModel,
      getType,
      platformData,
      getUpdatePlatform,
      displayData,
      getUpdateAdType,
      
    } = this.state;
    const {
      history,
      postCreationAdminMarginAction,
      tenantId,
      authToken,
      userId,
    } = this.props;


    const payload = {
      adminMargin: {
        campaignName: getCampaign.value,
        model: getModel.value,
        type: getType.value,
        value: form.marginValue,
        curPlatform: platformData[0].value,
        newPlatform: getUpdatePlatform.value,
        curAdtype: displayData[0].value,
        newAdType: getUpdateAdType.value,
      },
    };

    const {
      responseCode: { status = "", msg = "" },
    } = await postCreationAdminMarginAction({
      tenantId,
      authToken,
      userId,
      payload,
    });

    if (status) {
      this.toast(status, msg)
    }
  };

  UpdateAdminMargin = async (e) => {
    const {
      form,
      getCampaign,
      getModel,
      getType,
      platformData,
      getUpdatePlatform,
      displayData,
      getUpdateAdType,
    
    } = this.state;
    const {
      match: {
        params: { id },
      },
      history,
      postUpdatetionAdminMarginAction,
      tenantId,
      authToken,
      userId,
    } = this.props;

    // console.log("getType", getType);
    const payload = {
      adminMargin: {
        id: id,
        campaignName: getCampaign.value,
        model: getModel.value,
        type: getType.value,
        value: form.marginValue,
        curPlatform: platformData.value,
        newPlatform: getUpdatePlatform.value,
        curAdtype: displayData.value,
        newAdType: getUpdateAdType.value,
      },
    };

    const {
      responseCode: { status = "", msg = "" },
      // responseList,
    } = await postUpdatetionAdminMarginAction({
      tenantId,
      authToken,
      userId,
      payload,
    });

    if (status) {
      this.toast(status, msg);
    }
  };


  handleSave = (e) => {
    e.preventDefault();
    const {
      getCampaign,
      getModel,
      getType,
      getUpdateAdType,
      getUpdatePlatform,
      form
    } = this.state;

    const {
      match: {
        params: { id },
      },
    } = this.props;

    if (getCampaign == "") {
      this.setState({ validationCampaign: true });
    }

    if (getModel == "") {
      this.setState({ validationModel: true });
    }

    if (getType == "") {
      this.setState({ validationType: true });
    }

    if (getUpdatePlatform == "") {
      this.setState({ validationNewPlatform: true });
    }

    if (getUpdateAdType == "") {
      this.setState({ validationNewAdType: true });
    }


    let { errors, valid, } = handleError(form, formFields);
    if (valid &&  getCampaign != "" &&  getModel != "" && getType != ""  &&  getUpdatePlatform != "" && getUpdateAdType != "") {
        this.setState({ enableToast: true, confirmationMsg: "Kindly let us know if you'd like to save your changes.", toastMsg: "", toastStatus: "" });

    } 
    else if ( getCampaign == "" ||  getModel == "" || getType == "") {
      this.setState({ enableToast: true,  toastMsg: "All Fields Are Required.", toastStatus: "Fail" });
      this.setState({ errors: errors, submited: true });
    }else{
      // this.setState({ enableToast: true,  toastMsg: "All Fields Are Required.", toastStatus: "Fail" });
      this.setState({ errors: errors, submited: true });
    }

    // if (
    //   getCampaign == "" ||
    //   getModel == "" ||
    //   getType == "" ||
    //   getUpdatePlatform == "" ||
    //   getUpdateAdType == "" ||
    //   marginValue == ""
    // ) {
    //   this.setState({ enableToast: true, confirmationMsg: "All Fields Are Required.", toastMsg: "", toastStatus: "required" });
    // } else {
    //   this.setState({ enableToast: true, confirmationMsg: "Kindly let us know if you'd like to save your changes." });
    // }
  };

  toast = (status, msg) => {
    this.setState({ enableToast: true, toastStatus: status, toastMsg: msg });
    return;
  }

  confirmationCallbackModel = (id) => {
    this.setState({ enableToast: false });
    if (id != undefined) {
      this.UpdateAdminMargin();
    } else {
      this.createAdminMargin();
    }
  }

  handleToastStatus = (status) => {
    this.setState({ enableToast: status });
  }

  render() {
    const maxDate = new Date();
    const {
      confirmationOpen,
      confirmationInfo,
      submited,
      errors,
      touched,
      form,
      getCampaign,
      getModel,
      getType,
      getUpdatePlatform,
      getUpdateAdType,
      fetchCampaign,
      displayData,
      platformData,
      validationCampaign,
      validationModel,
      validationType,
      validationNewPlatform,
      validationNewAdType,
      
      validationValue,
      updatePlatformList,
      adTypesOption,
      enableToast,
      toastMsg,
      toastStatus,
      confirmationMsg
    } = this.state;
    const {
      ioAdvertisersReport,
      match: {
        params: { id },
      },
      match,
    } = this.props;
    // console.log(adTypesOption,"adTypesOption")

    return (
      <>
        {
          enableToast && <ToastModal
            enableToast={enableToast}
            status={toastStatus}
            msg={toastMsg}
            path={routes.containers.adminMargin}
            idProps={this.props}
            handleConfirmation={this.confirmationCallbackModel}
            handleToastStatus={this.handleToastStatus}
            confirmationMsg={confirmationMsg}
          />
        }

        {/* {confirmationOpen && (
          <ModalConfirmation
            open={confirmationOpen}
            onClose={this.toggleModal}
            confirmationInfo={confirmationInfo}
            handelConfirmationMessage={this.confirmationCallBack}
          />
        )} */}
        <div className="main-panel ion add-margin-adj">
          <div className="content-wrapper">
            <BreadCrumb />
            <div className="row justify-content-center mt-3">
              <div className="col-md-12 grid-margin">
                <Card>
                  <div className="d-flex justify-content-end">
                    {/* <button className="btn btn-primary">Go back</button> */}
                    <Link
                      to={
                        "/" +
                        routes.mainRoute +
                        "/" +
                        routes.containers.adminMargin
                      }
                    >
                      <button
                        type="button"
                        className="btn btn-primary">
                        <i className="mdi mdi-keyboard-backspace"></i>Go Back
                      </button>
                    </Link>
                  </div>
                  {/* </Card>
                <Card> */}
                  <form>
                    <div className="row">
                      <div className="col-md-6">
                        <label className="mt-3" style={{ fontSize: "14px" }}>
                          Campaign  <span className='text-danger'>*</span>
                        </label>
                        <Select
                          options={fetchCampaign}
                          className={validationCampaign ? "has-error" : ""}
                          // value={getCampaign ? getCampaign : console.log('required')}
                          value={Object.keys(getCampaign).length === 0 ? "" : getCampaign}
                          defaultValue={Object.keys(getCampaign).length === 0 ? "" : getCampaign}
                          onChange={(selected) =>
                            this.handleCampaignChange(selected)
                          }
                          isDisabled={id ? true : false}
                          placeholder="--Select--"
                        />
                        {validationCampaign ? (
                          <span className="error-message">
                            This field is required.
                          </span>
                        ) : (
                          ""
                        )}
                      </div>

                      <div className="col-md-6">
                        <label className="mt-3" style={{ fontSize: "14px" }}>
                          Margin Model  <span className='text-danger'>*</span>
                        </label>
                        <Select
                          className={validationModel ? "has-error" : ""}
                          options={ModelSelect}
                          value={Object.keys(getModel).length === 0 ? "" : getModel}
                          defaultValue={Object.keys(getModel).length === 0 ? "" : getModel}
                          placeholder="--Select--"
                          onChange={(selected) =>
                            this.handleAdminChange(selected)
                          }
                        />
                        {validationModel ? (
                          <span className="error-message">
                            This field is required.
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="col-md-6">
                        <label className="mt-3" style={{ fontSize: "14px" }}>
                          Margin type  <span className='text-danger'>*</span>
                        </label>
                        <Select
                          className={validationType ? "has-error" : ""}
                          options={ModelTypeSelect}
                          value={Object.keys(getType).length === 0 ? "" : getType}
                          defaultValue={Object.keys(getType).length === 0 ? "" : getType}
                          placeholder="--Select--"
                          onChange={(selected) =>
                            this.handleAdminChange(selected)
                          }
                        />
                        {validationType ? (
                          <span className="error-message">
                            This field is required.
                          </span>
                        ) : (
                          ""
                        )}
                      </div>

                      <div className="col-md-6 mt-2">
                      <Input
                        onChange={this.handleChange}
                        onBlur={this.handleTouch}
                        value={form[formFields.marginValue.key]}
                        setting={formFields[formFields.marginValue.key]}
                        error={errors[formFields.marginValue.key]}
                        submited={submited}
                        touched={touched[formFields.marginValue.key]}

                      />
                      </div>

                      <div className="col-12 pt-4">
                        <div className="col-md-12 p-0 btn-block text-left badgeText">
                          <p style={{ fontSize: '14px' }}>Platform</p>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <label className="mt-3" style={{ fontSize: "14px" }}>
                          Current   <span className='text-danger'>*</span>
                        </label>
                        <Select
                          options={updatePlatformList}
                          value={Object.keys(platformData).length === 0 ? "" : platformData}
                          onChange={(selected) =>
                            this.handleAdminChange(selected)
                          }
                          isDisabled={true}
                          placeholder="--Select--"
                        />
                      </div>

                      <div className="col-md-6">
                        <label className="mt-3" style={{ fontSize: "14px" }}>
                          Updated   <span className='text-danger'>*</span>
                        </label>
                        <Select
                          className={validationNewPlatform ? "has-error" : ""}
                          options={updatePlatformList}
                          // value={getUpdatePlatform}
                          defaultValue={Object.keys(getUpdatePlatform).length === 0 ? "" : getUpdatePlatform}
                          onChange={(selected) =>
                            this.handleAdminChange(selected)
                          }
                          placeholder="--Select--"
                        />
                        {validationNewPlatform ? (
                          <span className="error-message">
                            This field is required.
                          </span>
                        ) : (
                          ""
                        )}
                      </div>

                      <div className="col-12 pt-4">
                        <div className="col-md-12 p-0 btn-block text-left badgeText">
                          <p style={{ fontSize: '14px' }}>Ad Type</p>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <label className="mt-3" style={{ fontSize: "14px" }}>
                          Current   <span className='text-danger'>*</span>
                        </label>
                        <Select
                          options={adTypesOption}
                          value={Object.keys(displayData).length == 0 ? "" : displayData}
                          onChange={(selected) =>
                            this.handleAdminChange(selected)
                          }
                          isDisabled={true}
                          placeholder="--Select--"
                        />
                      </div>

                      <div className="col-md-6">
                        <label className="mt-3" style={{ fontSize: "14px" }}>
                          Updated  <span className='text-danger'>*</span>
                        </label>
                        <Select
                          className={validationNewAdType ? "has-error" : ""}
                          options={adTypesOption}
                          // value= {getUpdateAdType}
                          defaultValue={Object.keys(getUpdateAdType).length == 0 ? "" : getUpdateAdType}
                          onChange={(selected) =>
                            this.handleAdminChange(selected)
                          }
                          placeholder="--Select--"
                        />
                        {validationNewAdType ? (
                          <span className="error-message">
                            This field is required.
                          </span>
                        ) : (
                          ""
                        )}
                      </div>

                      <div
                        className="form-group row mt-5"
                        style={{ width: "100%" }}
                      >
                        <div className="col-md-12">
                          <center>
                            <button
                              type="submit"
                              onClick={(e) => this.handleSave(e)}
                              className="btn btn-primary mr-4"
                            >
                              Save
                            </button>
                            <Link
                              to={
                                "/" +
                                routes.mainRoute +
                                "/" +
                                routes.containers.adminMargin
                              }
                            >
                              <button
                                type="button"
                                className="btn btn-secondary"
                              >
                                Cancel
                              </button>
                            </Link>
                          </center>
                        </div>
                        {/* <button onClick={(e) => this.validateField(e)}>Test</button> */}
                      </div>
                    </div>
                  </form>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default connect(
  (state) => ({
    configurationList: get(state, "app.configurationData.responseList", []),
    ioAdvertisersReport: get(state, "app.ioAdvertisersReport.responseList", []),
    tenantId: get(state, "app.preSignInState.tenantId", ""),
    userId: get(state, "app.preSignInData.userId", ""),
    authToken: get(state, "app.signInData.authToken", ""),
  }),
  {
    // addIoReportAction,
    getPlaformWiseAction,
    getAllCampaignListAction,
    postCreationAdminMarginAction,
    getListByIdAdminMarginAction,
    postUpdatetionAdminMarginAction,
  }
)(index);

// ----*  IO propTypes * ----
index.propTypes = {
  addIoReportAction: PropTypes.func,
  getIoAdvertisersReportAction: PropTypes.func,
  configurationList: PropTypes.array,
  ioAdvertisersReport: PropTypes.array,
};
